import React, { useEffect, useState } from "react";
import { Checkbox, Button, Input } from "antd";
import type { PopProjectItem } from "./board"

import "./index.scss"

interface PopProjectsProps {
    list?: API.PROJECT.OverviewProject[],
    value?: number[],
    onCheckedChange: (v: number[]) => void,
    onHide: () => void
}
export const PopProjects: React.FC<PopProjectsProps> = (props) => {
    const [list, setList] = useState<PopProjectItem[]>(props.list || []);
    const [renderList, setRenderList] = useState<PopProjectItem[]>(props.list || []);
    const [searchText, setSearchText] = useState("");
    useEffect(() => {
        const newList = props.list?.map(v => {
            return {
                ...v,
                isSelected: props.value?.includes(v.id) || false
            }
        }) || [];
        setRenderList(newList)
        setList(newList);
    }, [props.list, props.value]);
    const onSelect = (v: PopProjectItem) => {
        setList((prev) => {
            return prev.map(item => {
                if (item.id === v.id) {
                    return {
                        ...item,
                        isSelected: !item.isSelected
                    }
                }
                return item
            })
        });
        setRenderList((prev) => {
            return prev.map(item => {
                if (item.id === v.id) {
                    return {
                        ...item,
                        isSelected: !item.isSelected
                    }
                }
                return item
            })
        })
    }
    const onClear = () => {
        setList((prev) => {
            return prev.map(item => {
                return { ...item, isSelected: false }
            })
        });
        setRenderList(list.map(item => {
            return { ...item, isSelected: false }
        }))
        setSearchText("");
    }
    const onSelectAll = () => {
        const ids = renderList.map(item => item.id)
        setList((prev) => {
            return prev.map(item => {
                return { ...item, isSelected: item.isSelected || ids.includes(item.id) }
            })
        });
        setRenderList((prev) => {
            return prev.map(item => {
                return { ...item, isSelected: item.isSelected || ids.includes(item.id) }
            })
        })
    }
    const onSelectEditable = () => {
        const ids = renderList.filter(v=>v.createMilestone).map(item => item.id)
        setList((prev) => {
            return prev.map(item => {
                return { ...item, isSelected: item.isSelected || ids.includes(item.id) }
            })
        })
        setRenderList((prev) => {
            return prev.map(item => {
                return { ...item, isSelected: item.isSelected || ids.includes(item.id) }
            })
        })
    }
    const onSelectWorkHour = () => {
        const ids = renderList.filter(v => v.defaultSelected).map(item => item.id)
        setList((prev) => {
            return prev.map(item => {
                return { ...item, isSelected: item.isSelected || ids.includes(item.id) }
            })
        })
        setRenderList((prev) => {
            return prev.map(item => {
                return { ...item, isSelected: item.isSelected || ids.includes(item.id) }
            })
        })
    }
    const onSubmit = () => {
        const ids = list.filter(v => v.isSelected).map(v => v.id)
        props.onHide()
        props.onCheckedChange(ids);
        
    }

    const onSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const text = e.target.value;
        setSearchText(text);
        if (text) {
            const filtered = list.filter(v => v.name.includes(text) || v.code.includes(text));
            setRenderList(filtered);
        } else {
            setRenderList(list);
        }
    }
    return (
        <div className="bg-white box-shadow max-w-md py-2 px-4 rounded-md">
            <div className="relative">
                <span className="font-bold text-base">项目</span>
            </div>
            <div className="py-1">
                <Input placeholder="搜索项目" onChange={onSearchTextChange} value={searchText}></Input>
            </div>
            <div className="max-h-96 overflow-y-auto">
                {renderList.map((v) => (
                    <div key={v.id} className="flex items-start py-1 cursor-pointer hover:bg-gray-100" onClick={() => onSelect(v)}>
                        <Checkbox checked={v.isSelected} />
                        <div className="ml-2 select-none">{v.code}{v.name}</div>
                    </div>
                ))}
            </div>
            {renderList.length === 0 && (
                <div className="py-24 text-xs text-gray-400 text-center">暂无项目数据</div>
            )}
            <div className="flex items-center justify-between pt-2">
                <div className="flex items-center text-xs gap-2">
                    <Button onClick={onSelectAll} size="small" className="text-xs">全选</Button>
                    <Button size="small" onClick={onSelectEditable} className="text-xs">选中可编辑项目</Button>
                    <Button onClick={onSelectWorkHour} size="small" className="text-xs">选中有工时项目</Button>
                    <Button onClick={onClear} size="small" className="text-xs">清除所有</Button>
                </div>

                <Button type="primary" className="ml-2" onClick={onSubmit}>应用</Button>
            </div>
        </div>
    )
}